import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { rememberPostAuthRedirect } from "@/utils/postAuthRedirect";

/**
 * Guard for routes that require authentication.
 * - Shows a loading state while we check /api/auth/me.
 * - Redirects to /login if unauthenticated.
 * - Redirects Google users with no role to /complete-profile.
 */
export default function ProtectedRoute({ children, allowNoRole = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1C3F] text-slate-200">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-2 border-sky-400 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-400">Verifying session…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    if (location.pathname === "/parent-quiz") rememberPostAuthRedirect("/parent-quiz");
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // User authenticated but no role → force profile completion (Google OAuth path)
  if (!user.role && !allowNoRole) {
    return <Navigate to="/complete-profile" replace />;
  }

  return children;
}
